/**
 * Acceso.
 *
 * Requiere red, y es correcto que así sea: sin haber iniciado sesión nunca,
 * la tablet no tiene catálogo ni mesas, así que no habría nada que mostrar.
 * Una vez adentro, el token y los datos quedan guardados y la app arranca
 * offline las veces siguientes.
 *
 * El login por PIN (`POST /api/auth/pin`) ya existe en el backend y entra
 * cuando se construya el bloqueo de caja entre operaciones.
 */

import { useState, type FormEvent } from 'react';
import * as api from '../api/endpoints';
import { ErrorApi, ErrorRed } from '../api/cliente';
import { dispositivoId } from '../lib/uuid';
import type { RespuestaLogin } from '../tipos/contrato';

import LogoLordaen from '../assets/images/logo-l_fhd.png';
import { nombreDispositivo } from '../lib/uuid';

export function Login({ onEntrar }: { onEntrar: (r: RespuestaLogin) => void }) {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setCargando(true);
    try {
      onEntrar(await api.login(usuario.trim(), password, dispositivoId(), nombreDispositivo()));
    } catch (err) {
      if (err instanceof ErrorRed) {
        setError('No hay conexión con el servidor. Verificá que la API esté corriendo.');
      } else if (err instanceof ErrorApi) {
        setError(err.message);
      } else {
        setError('No se pudo iniciar sesión.');
      }
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login">
      <form className="card" onSubmit={(e) => void enviar(e)}>
        <div className="marca"><img src={LogoLordaen} alt="Lordaen" /></div>
        <h1>Lordaen</h1>
        <p className="sub">Punto de venta · ingresá con tu usuario</p>

        {error && <div className="error-caja">{error}</div>}

        <div className="field">
          <label htmlFor="usuario">Usuario</label>
          <input
            id="usuario"
            autoFocus
            autoComplete="username"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="clave">Contraseña</label>
          <input
            id="clave"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width: '100%', padding: 13, marginTop: 6 }}
          disabled={cargando || !usuario || !password}
        >
          {cargando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
